import { createActionThunk } from "redux-thunk-actions";
import {
  MESSAGING_INITIALIZATION,
  ON_CHANGE_MESSAGE_FORM,
  ON_SUBMIT_MESSAGE,
  MESSAGE_TOGGLE,
  MESSAGE_DELETE,
  CLEAR_MESSAGE,
  MESSAGE_SAVE_DRAFT,
  SELECTED_FOR_EDIT_MESSAGE,
  MESSAGE_FILTER,
  MESSAGE_PUBLISH_DRAFT,
  CLEAR_DIRTY_DRAFT,
  RECALC_REQUEST,
  RECALC_SUCCESS,
  CLEAR_RECALC_SUCCESS,
  RECALC_FAILURE,
} from "./constant";
import {
  messageSubmit as messageSubmitService,
  publishDraft,
  messageUpdateService,
  recalcUnits as recalcUnitsService,
} from "../services/MessageService";
import { getMessages, deleteConversation } from "../services/MessageService";
import { parseFractionalNumber } from "../lib/helper";

const messageSubmit = createActionThunk(ON_SUBMIT_MESSAGE, (message) =>
  messageSubmitService(message)
);
const messageUpdate = createActionThunk(ON_SUBMIT_MESSAGE, (message) =>
  messageUpdateService(message)
);

const initialize = createActionThunk(
  MESSAGING_INITIALIZATION,
  async (userID) => {
    const messages = await getMessages(userID);
    return { messages };
  }
);

const onChangeForm = (e, name, id) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_MESSAGE_FORM,
      value: e,
      name: name,
      myId: id,
    });
  };
};

const messageToggle = (message, index) => {
  return (dispatch) => {
    dispatch({
      type: MESSAGE_TOGGLE,
      id: message._id ? message._id : message.post_id,
      index,
    });
  };
};

// Correct thunk: (dispatch, getState) in that order, single function
const messageDelete = (id) => (dispatch, getState) => {
  if (process.env.NODE_ENV !== "production") {
    const s = (getState() && getState().message) || {};
    const findIn = (arr) =>
      Array.isArray(arr)
        ? arr.find((it) => String((it && it._id) || (it && it.post && it.post._id)) === String(id))
        : null;
  }

  // fire-and-forget; or await if you want to block on the API call
  deleteConversation(id);

  dispatch({ type: MESSAGE_DELETE, id });
};

const clearMessage = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_MESSAGE,
    });
  };
};

const saveDraft = () => {
  return (dispatch) => {
    dispatch({
      type: MESSAGE_SAVE_DRAFT,
    });
  };
};

const selectForEdit = (conId, postId, index) => {
  return (dispatch) => {
    dispatch({
      type: SELECTED_FOR_EDIT_MESSAGE,
      conId,
      postId,
      index,
    });
  };
};

const messageFilter = (sortBy) => {
  return (dispatch) => {
    dispatch({
      type: MESSAGE_FILTER,
      sortBy: sortBy,
    });
  };
};
const clearDirtyDraft = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_DIRTY_DRAFT,
    });
  };
};
const onPublishDraft = createActionThunk(
  MESSAGE_PUBLISH_DRAFT,
  async (draftId) => {
    return await publishDraft(draftId);
  }
);
const convertContributedItemUnit = (item, form) => {
  const asNumberString = (v) => (v && v.$numberLong ? String(v.$numberLong) : v ? String(v) : "");

  // TEMP: Get from backend key or get from message content
  const extractUpc = (item) => {
    if (item.upc) return String(item.upc);
    // when upc key is missing grab upc from message content
    const m = (item.content || "").match(/\bupc\s+(\d+)\b/i);
    return m ? m[1] : "";
  };

  // ✅ Parse fractions/mixed numbers/normal numbers
  const parsedT12Amount = parseFractionalNumber(form.TwelveU12Amount);
  const parsedUserAmount = parseFractionalNumber(form.userAmount);
  const conversionFactor = parsedT12Amount / parsedUserAmount;

  const buildRecalcPayload = (item, form) => ({
    message_id: item._id,
    final_unit_id: form.TwelveU12Unit,
    conv: conversionFactor,
    final_id: asNumberString(item.final_id),
    current_id: asNumberString(item.current_id),
    category: item.current_category,
  });

  return async (dispatch) => {
    dispatch({ type: RECALC_REQUEST, meta: { messageId: item && item._id } });

    try {
      // const upc = extractUpc(item);
      const upc = item.upc;
      if (!upc) {
        const err = new Error("UPC not found in message content");
        err.code = "NO_UPC";
        throw err;
      }

      const payload = buildRecalcPayload(item, form);
      await recalcUnitsService(upc, payload);

      dispatch({ type: RECALC_SUCCESS, meta: { messageId: item && item._id } });

      // ✅ After a successful conversion, remove the specific
      // "Incompatible Measurement Unit" message container from the inbox
      if (item && item._id) {
        try {
          await dispatch(messageDelete(item._id));                                  // ✅ server delete + optimistic UI
        } catch (e) {
          // optional: log, but don't block the success prompt
          console.warn("Delete message failed:", e);
        }
      }

    } catch (error) {
      dispatch({ type: RECALC_FAILURE, error: true, payload: error, meta: { messageId: item && item._id } });
      throw error; // let the caller (your component) handle UX (modal reopen / toast)
    }
  };
};

const clearRecalcSuccess = () => ({
  type: CLEAR_RECALC_SUCCESS,
});

export default {
  initialize,
  onChangeForm,
  messageSubmit,
  messageToggle,
  messageDelete,
  clearMessage,
  saveDraft,
  selectForEdit,
  messageFilter,
  onPublishDraft,
  messageUpdate,
  clearDirtyDraft,
  convertContributedItemUnit,
  clearRecalcSuccess,
};



// WEBPACK FOOTER //
// ./src/actions/messageActions.js